import { RouteManager } from "routes"
import { PermissionState } from "auth"
import { AppRoutes } from "enums/routes"

export function GetRouteManagerFactory(routes: AppRoutes) {
	return (perms: PermissionState) =>
		new RouteManager(routes, perms.menuList, perms.businessObjList)
}

export const RouteManagerFactory = GetRouteManagerFactory(AppRoutes)
